import React, { useState, useEffect } from "react";
import Kard from "./Kard";
import Qidiruv from "./Qidiruv";
import Yonalish from "./Yonalish";
import QiymatSarlavha from "./Qiymat-sarlavha";
import "./Qiymat.css";

function Qiymat({
  kurslar,
  mavzu,
  mavzuSoni,
  kurs_id,
  setKurs_id,
  filterType,
  activeMavzu,
  setActiveMavzu,
  userData,
  refreshUserData,
  handleLogout,
  darajalar
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchMode, setIsSearchMode] = useState(false); // Explicit mode tracking

  const filteredKurslar = kurslar.filter(course =>
    course.nomi && course.nomi.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // When searching, default to highlighting the first course in the results (visual only)
  const firstCourseId = filteredKurslar.length > 0 ? filteredKurslar[0].id : (kurslar.length > 0 ? kurslar[0].id : 0);
  const effectiveKursId = isSearchMode ? firstCourseId : kurs_id;

  // Calculate topic name (use first topic if we just switched to search)
  const activeTopicName =
    effectiveKursId === 0
      ? ""
      : (Array.isArray(mavzu) && (mavzu[activeMavzu] || mavzu[0])
        ? ((mavzu[activeMavzu] || mavzu[0]).nomi || "Kurs haqida")
        : "Kurs haqida");

  // Hide lesson count if no course selected
  const displayMavzuSoni = effectiveKursId === 0 ? "" : mavzuSoni;


  // When typing, trigger search mode (blur)
  useEffect(() => {
    setIsSearchMode(!!searchTerm);
  }, [searchTerm]);

  // Handle selection: Turn off search mode to show details
  // Note: API fetch is handled by effect in Loyiha.js when kurs_id changes
  const handleCourseSelect = (id) => {
    setKurs_id(id);
    setIsSearchMode(false);
  };

  return (
    <div className="qiymat-quti">
      <Qidiruv onSearch={setSearchTerm} searchTerm={searchTerm} />
      <Kard
        kurslar={filteredKurslar}
        setKurs_id={handleCourseSelect}
        filterType={filterType}
        kurs_id={effectiveKursId}
        setActiveMavzu={setActiveMavzu}
      />
      <QiymatSarlavha mavzuSoni={displayMavzuSoni} activeTopicName={activeTopicName} />
      <Yonalish
        kurslar={kurslar.find(k => k.id === effectiveKursId) || {}}
        mavzu={mavzu}
        kurs_id={effectiveKursId}
        activeMavzu={activeMavzu}
        setActiveMavzu={setActiveMavzu}
        filterType={filterType}
        userData={userData}
        refreshUserData={refreshUserData}
        handleLogout={handleLogout}
        isSearchMode={isSearchMode}
        darajalar={darajalar}
      />
    </div>
  );
}

export default Qiymat;
